import BlogArticleCategorySearch from '$lib/storyblok/blocks/blogArticleCategorySearch.svelte';
import BlogParagraph from '$lib/storyblok/blocks/blogParagraph.svelte';
import BlogPage from '$lib/storyblok/pages/blogPage.svelte';
import BlogImage from '$lib/storyblok/blocks/blogImage.svelte';
import BlogVideo from '$lib/storyblok/blocks/blogVideo.svelte';
import BlogShareModule from '$lib/storyblok/blocks/blogShareModule.svelte';
import BlogArticleList from '$lib/storyblok/blocks/blogArticleList.svelte';
import Page from '$lib/storyblok/pages/page.svelte';
import BlogQuote from '$lib/storyblok/blocks/blogQuote.svelte';
import BlogAdditionalInfo from '$lib/storyblok/blocks/blogAdditionalInfo.svelte';
import BlogTeamSlider from '$lib/storyblok/blocks/blogTeamSlider.svelte';
import BlogTeamMember from '$lib/storyblok/blocks/blogTeamMember.svelte';
import defaultComponents from '$lib/storyblok/defaultComponents';
import { registerComponents } from '$lib/storyblok/sdk';

registerComponents({
	...defaultComponents,
	page: Page,
	blog_page: BlogPage,
	blog_article_list: BlogArticleList,
	blog_paragraph: BlogParagraph,
	blog_image: BlogImage,
	blog_video: BlogVideo,
	blog_quote: BlogQuote,
	blog_additional_info: BlogAdditionalInfo,
	blog_article_category_search: BlogArticleCategorySearch,
	blog_share_module: BlogShareModule,
	blog_team_slider: BlogTeamSlider,
	blog_team_member: BlogTeamMember
});
